/***
 * Created on 2023/8/25
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import {useTranslation} from "react-i18next";
import {usePreCheckPassword} from "../../../../hook/pre_check_password";
import QnapAuthPanel from "./qnap_auth_app/qnap_auth_manager/qnap_auth_panel";
import QnapAuthPairDevicePanel from "./qnap_auth_app/qnap_auth_manager/qnap_auth_pair_device_panel";
import {useQuery} from "@tanstack/react-query";
import {apiGet} from "../../../../service/api";


function CurrentTwoStep({dispatch, state}) {
    const { t } = useTranslation();
    const {checkPassword} = usePreCheckPassword();

    const {data} = useQuery({
        queryKey: ['profile'],
        queryFn: async () => {
            const data = await apiGet('/ajax/profile');
            localStorage.setItem('currentUser', JSON.stringify(data));
            return data;
        }
    });

    const onSwitch = async () => {
        await checkPassword({
            onSuccess: () => dispatch({type: 'toggleDisable', value: true}),
            onError: () => dispatch({type: 'toggleVerifyPassword', value: true, openAfterPassVerified: 'toggleDisable'})
        });
    }

    return (
        <>
            <section className="two-step--ctrl">
                <header>{t('@2-Step Verification@')}</header>
                <div className="comp-content-wrapper">
                    <div className="two-step--setting__row">
                        <div className="two-step--setting__row__col-center set-divide-right">
                            {t('@Your account is now protected by both your password and your phone. You will need to enter your email and password, as well as a unique verification code generated by an app on your mobile device or received via SMS.@')}
                        </div>
                        <div className="two-step--setting__row__col-right">
                            <div className="comp-switch">
                                <div className="q-switch switch-on" onClick={onSwitch}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <QnapAuthPanel />

            <QnapAuthPairDevicePanel state={state} dispatch={dispatch}/>
        </>
    );
}

export default CurrentTwoStep;